
<div class="modal-window" @dragenter.prevent="dragEnter" @dragleave.prevent="dragLeave" @dragend.prevent="dragEnd">
  <div class="container-fluid">
    <slot name="dropzone"></slot>
    <div class="row">
      <div :class="mainClass">
        <div class="row">
          <div class="col-12" :class="modalPaddings">
            <slot>PUT CONTENT HERE</slot>
          </div>
        </div>
      </div>

      <div class="sidebar pt-4 pb-3" :class="sideBarClass">
        <slot name="sidebar"></slot>
      </div>
    </div>
  </div>
</div>
